import { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import styles from "./DownTime.module.less";
import { tSetTimeout, tSetInterval, tClearInterval } from "./TimestampTimer";

const DownTime = forwardRef(({ onTimeChange, onTimeEnd }, ref) => {
  const [time, setTime] = useState(0);
  const [totalTime, setTotalTime] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const [displayTime, setDisplayTime] = useState(0);
  const [isInitialized, setIsInitialized] = useState(false);

  const startCountdown = (startTime) => {
    if (typeof startTime !== "number" || isNaN(startTime) || startTime <= 0) {
      console.error("startTime must be a number greater than 0");
      startTime = 5;
    }
    setTime(startTime);
    setTotalTime(startTime);
    setDisplayTime(startTime);
    setIsRunning(true);
    setIsInitialized(true);
  };

  const stopCountdown = () => {
    setIsRunning(false);
  };

  useImperativeHandle(ref, () => ({
    startCountdown,
    stopCountdown,
  }));

  // 监听倒计时结束
  useEffect(() => {
    if (displayTime <= 0 && isRunning) {
      setIsRunning(false);
      onTimeEnd?.();
    }
  }, [displayTime, isRunning, onTimeEnd]);

  // 倒计时逻辑
  useEffect(() => {
    let timer;
    if (isRunning && time > 0) {
      timer = tSetInterval(() => {
        setTime((prevTime) => {
          const newTime = prevTime - 1;
          onTimeChange?.(newTime);

          tSetTimeout(() => {
            setDisplayTime(newTime);
          }, 1000);

          return newTime;
        });
      }, 1000);
    }

    return () => {
      if (timer) {
        tClearInterval(timer);
      }
    };
  }, [isRunning, onTimeChange]);

  const remainingTimePercent = isInitialized ? (time / totalTime) * 100 : 100;
  const progressPercent = Math.min(100 - remainingTimePercent, 100);
  const elementProgressPercent = progressPercent * 0.79;

  return (
    <div className={styles["down-time-container"]}>
      {isRunning && (
        <div
          className={styles["back-box"]}
          style={{
            "--progress-percent": `${elementProgressPercent}%`,
          }}
        >
          <div
            className={styles["progress-box"]}
            style={{
              clipPath: isInitialized
                ? `inset(0 0 0 ${progressPercent}%)`
                : "none",
              transition: isInitialized ? "all 1s linear" : "none",
            }}
          >
            <div className={styles["progress"]}></div>
          </div>
          <div className={styles["clock"]}>
            <div className={styles["clock-text"]}>
              {Math.max(displayTime, 0)}s
            </div>
          </div>
        </div>
      )}
    </div>
  );
});

export default DownTime;
